<template>
    <div class="transaction">
  
      <Header :mainHeader="true"/>
  
      <section id="transaction-products" style="padding: 10px 0px !important">
        <div class="containers">
          <h5 class="fw-bold">Credit Note Invoices</h5>

          <div class="table-container">
            <table class="table table-hover" id="invoicesTable"  style="width: 100% !important">
                <thead>
                    <tr>
                        <th>No</th>
                        <th>Invoice No.</th>
                        <th>Original Invoice No.</th>
                        <th>Sales Date</th>
                        <th>Items</th>
                        <th>Amount</th>
                        <th>Tax</th>
                    </tr>
                </thead>
                  <!-- <tbody v-if="sales">
                    <tr v-for="(sale,index) in sales" v-bind:key="sale.id">
                        <td>{{ index+1 }}</td>
                        <td>{{ sale.invcNo }}</td>
                        <td>{{ sale.orgInvcNo }}</td>
                        <td>{{ sale.salesDt }}</td>
                        <td>{{ sale.totItemCnt }}</td>
                        <td>KES {{ formatToMoney(sale.totAmt) }}</td>
                        <td>KES {{ formatToMoney(sale.totTaxAmt) }}</td>
                    </tr>
                  Add more rows as needed 
                </tbody>
                <p v-else>No Credit Note found</p>-->
             </table>
             <LoaderItem v-if="loading" />
          </div>
          
        </div>
      </section>
  
    </div>
  </template>
  
<script>

import Header from '../../components/Header';
import Swal from 'sweetalert2'
import 'datatables.net-vue3';
import 'datatables.net-bs5';
import "datatables.net-buttons-bs5";
import "datatables.net-responsive-bs5";
import $ from 'jquery';
//import 'jszip';
import 'datatables.net-buttons/js/buttons.html5.js';
import 'datatables.net-buttons/js/buttons.html5.js';
import 'datatables.net-buttons/js/buttons.colVis.js';
import 'datatables.net-buttons/js/buttons.print.js';
import { formatDate } from '@/utils/commons';
import LoaderItem from "../../components/LoaderItem.vue"


export default {
name: 'CreditPage',
components: {
    Header,
    LoaderItem
},
data(){
    return{
        token: JSON.parse(localStorage.getItem('access_token')),
        sales: [],
        processedData: [], 
        loading: false
    }
},
methods:{
    formatToMoney(value) {
        const formattedValue = Number(value).toFixed(2);
        return formattedValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    
    async getSales () {
        const requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json", 'Authorization': 'Bearer '+this.token },
        };
                
        try {
            this.loading = true
            const res = await fetch(process.env.VUE_APP_URL + '/credit', requestOptions);
            const data = await res.json();

            if (data.status === true) {
                this.sales = data.credit;
                this.processedData = this.preprocessData(this.sales);
                this.initializeDataTable();
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Credit not found',
                    text: data.message
                });
            }
        } catch (error) {
            //console.error('Error fetching or parsing data:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Failed to fetch credit data. Please try again later.'
            });
        } finally {
            this.loading = false
        }
    },

    preprocessData(rawData) {
      return rawData.map(item => {
        return {
          indexNo: "1",
          invoiceNo: item.invcNo,
          orgInvoiceNo: item.orgInvcNo,
          salesDt: item.salesDt,
          items: item.totItemCnt,
          amount: this.formatToMoney(item.totAmt),
          tax: this.formatToMoney(item.totTaxAmt)      
        };
      });
    },

    initializeDataTable() {
    try {
        this.dataTable = $(this.$el).find('#invoicesTable').DataTable({
        responsive: true,
        language: {
            paginate: {
            previous: '<i class="fa fa-chevron-left"></i>', // Custom icon for previous button
            next: '<i class="fa fa-chevron-right"></i>', // Custom icon for next button
            },
        }, 
        dom: '<"datatable-buttons"B><"datatable-search"f>tip',
        buttons: [
            {
            extend: 'colvis',
            text: 'Column Visibility',
            className: 'btn-grey',
            },
            {
            extend: 'pageLength',
            text: 'Page Length',
            className: 'btn-grey',
            },
            {
            extend: 'csv',
            text: 'Export CSV',
            className: 'btn-grey',
            exportOptions: {
                columns: ':visible',
            },
            },
            {
            extend: 'pdfHtml5',
            text: 'Export PDF',
            orientation: 'landscape',
            className: 'btn-grey',
            exportOptions: {
                columns: ':visible',
            },
            customize: this.customizePDF
            },
        ],
        data: this.processedData,
        columns: [
            { data: null },
            { data: 'invoiceNo' },
            { data: 'orgInvoiceNo' },
            { data: 'salesDt' },
            { data: 'items' },
            { data: 'amount' },

        ],
        columnDefs: [
            {
            targets: 0,
            searchable: false,
            orderable: false,
            render: (data, type, row, meta) => {
                return meta.row + 1;
            },
            },
        ],
        });
    } catch (error) {
        console.log({ error })
    }
    },


        
    customizePDF(doc) {
        //const logoBase64 = this.convertToBase64(logo)
        //console.log(logoBase64)
        doc.pageMargins = [40, 40, 40, 40]; // Set margins for the entire page
        doc.defaultStyle.columnGap = 0
        doc.content[1].fillColor = '#f2f2f2'

        doc.header = () => {
            return {
            columns: [
                {
                width: '*',
                columns: [
                    /* {
                        image: logoBase64,
                        width: 150, // Adjust the width as needed
                    },*/
                    {
                    text: 'Taxpoint',
                    alignment: 'left',
                    margin: [40, 15, 0, 40], // Adjust margins as needed
                    color: '#000', 
                    bold: true,
                    fontSize: 14,

                    }
                ]
                },
                {
                width: '*',
                stack: [
                    {
                    text: 'Products List',
                    alignment: 'right',
                    margin: [0, 15, 50, 0],
                    fontSize: 12,
                    color: '#4448B3'
                    },
                    {  
                    alignment: 'right',
                    margin: [300, 0, 0, 0],
                    width: '*',
                    columns: [
                        {
                        width: 'auto',
                        text: 'Date:',
                        alignment: 'right',
                        margin: [0, 0, 10, 0],
                        bold: true,
                        },
                        {
                        width: 'auto',
                        text: `${formatDate(new Date(), "true")}`,
                        alignment: 'right',
                        margin: [0, 0, 50, 0],
                        fontSize: 9
                        }
                    ]
                    }
                ]
                }
            ],
            fillColor: '#000000'
            };
        },

        doc.footer = (currentPage, pageCount) => {
            return {
                columns: [
                { width: '*', text: 'www.pavicongroup.co.ke', alignment: 'left' },
                { width: '*', text: 'contact@pavicongroup.co.ke', alignment: 'center' },
                { width: '*', text: `Page ${currentPage} of ${pageCount}`, alignment: 'center' },
                { width: '*', text: `Printed on ${formatDate(new Date(), "true")}`, alignment: 'right' }
                ],
                margin: [40, 10, 40, 10], // Margin for the whole footer
                fillColor: 'black'
            };
        };   

        doc.styles.title = {
            color: '#4448B3',
            fontSize: 13,
            margin: [80, 0, 0, 40],
        };
    }


},
mounted(){
    this.getSales()
}
}
</script>